"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var FlagNL = function (_a) {
    var className = _a.className;
    return (react_1.default.createElement("svg", { className: className, height: '1em', viewBox: '0 0 24 24', width: '1em', xmlns: 'http://www.w3.org/2000/svg' },
        react_1.default.createElement("title", null, "Flag of the Netherlands"),
        react_1.default.createElement("g", { fill: 'none', fillRule: 'evenodd' },
            react_1.default.createElement("path", { d: 'M21 5H3c-.55 0-1 .45-1 1v3.999h20V6c0-.55-.45-1-1-1', fill: '#EA3E47' }),
            react_1.default.createElement("path", { d: 'M2 17.998c0 .551.45 1 1 1h18c.55 0 1-.449 1-1v-3.999H2v3.999z', fill: '#0068B2' }),
            react_1.default.createElement("path", { fill: '#FFF', d: 'M2 13.998h20v-4H2z' }),
            react_1.default.createElement("path", { d: 'M0 0h24v24H0z' }))));
};
exports.default = FlagNL;
